export const TIME_PICKER_TEMPLATES = {
	hours: new Array(12).fill(0).map((el, i) => i + 1),
	minutes: new Array(12).fill(0).map((el, i) => (i === 0 ? i : i * 5)),
};
